var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBlueLineOne = function SvgBlueLineOne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 9,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.254c13.472-.811 50.651-2.243 103.406-2.371 42.497-.103 95.102.64 153.562 3.235",
    stroke: "#909FFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
};
export default SvgBlueLineOne;